<template>
    <transition name="fade">
        <div v-if="active" class="fixed z-20 inset-0 overflow-y-auto">
            <div
                class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
                <div class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                ></span
                >&#8203;
                <!--
            Modal panel, show/hide based on modal state.

            Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
            Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
                <div
                    class="inline-block align-bottom bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full"
                    :class="{ 'sm:max-w-xl': !!deleteOptions, 'sm:max-w-lg': !deleteOptions }"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                            <div
                                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                            >
                                <svg
                                    class="h-6 w-6 text-red-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    />
                                </svg>
                            </div>
                            <div
                                class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                            >
                                <h3
                                    class="text-lg leading-6 font-medium text-gray-900 dark:text-white"
                                    id="modal-headline"
                                >
                                    Delete
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm leading-5 text-gray-500 dark:text-gray-200">
                                        Are you sure you want to delete this?
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                            v-if="!deleteOptions"
                        >
                            <button
                                @click="handleDeleteBtnClick"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Delete
                            </button>
                        </span>

                        <span
                            class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                            v-if="deleteOptions"
                            v-for="button in (deleteOptions && deleteOptions.buttons || [])"
                            v-tooltip="button.buttonTooltip"
                        >
                            <button
                                @click="() => handleDeleteBtnClick(button.requestBody)"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :disabled="button.buttonDisabled"
                            >
                                {{ button.buttonText }}
                            </button>
                        </span>

                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                        >
                            <button
                                @click.prevent="$emit('close')"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue-200 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Cancel
                            </button>
                        </span>
                    </div>

                    <div class="bg-gray-600 px-4 pt-4 pb-4"
                        v-if="deleteOptions && deleteOptions.deleteModalText">
                        <p class="leading-5 text-white" v-html="deleteOptions.deleteModalText">
                            {{ deleteOptions.deleteModalText }}
                        </p>
                    </div>
                </div>
            </div>
            <form ref="deleteForm" :action="deleteRoute" method="POST">
                <input type="hidden" name="_token" :value="csrf" />
                <input type="hidden" name="_method" value="delete" />
                <input
                    v-for="param in requestBody"
                    type="hidden"
                    :name="param.key"
                    :value="param.value"
                />
            </form>
        </div>
    </transition>
</template>

<script>
export default {
    name: "delete-modal",
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        deleteRoute: {
            type: String,
            required: true,
        },
        deleteOptions: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            isModalOpen: false,
            requestBody: null,
        };
    },
    methods: {
        handleDeleteBtnClick: function (requestBody) {
            if (!!requestBody) {
                this.requestBody = requestBody;
            }
            else {
                this.requestBody = null;
            }

            this.$nextTick(() => {
                this.$refs["deleteForm"].submit()
            });
        },
    },
};
</script>
